import React from "react";
import "../css/Loading.css";

const Success = () => {
    return (
        <div className="success-container">
            <h2>Your form has been submitted successfully!</h2>
            <p>Thank you for contacting us. We will get back to you shortly.</p>
        </div>
    );
};

export default Success;
